import { Box, styled } from '@mui/material';
export const Widget = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(2),
}));
export const Page = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(3),
    paddingLeft: 'calc(24px + 3%)',
    paddingRight: 'calc(24px + 3%)',
    paddingTop: 96,
    paddingBottom: 96,
}));
